export default {"src":"/_next/static/media/flexible-support.12cb3f52.svg","height":48,"width":56};